import * as React from 'react'
  /* @jsx mdx */
import { mdx } from '@mdx-js/react';
/* @jsx mdx */

export const _frontmatter = {};
const layoutProps = {
  _frontmatter
};
const MDXLayout = "wrapper";
export default function MDXContent({
  components,
  ...props
}) {
  return <MDXLayout {...layoutProps} {...props} components={components} mdxType="MDXLayout">
    <p>{`台灣領域驅動設計社群 (DDD Taiwan Community) 發起人之一。喜歡揉合各種開發方法並且實驗,立志貫通完整的產品流程。`}</p>

    </MDXLayout>;
}
;
MDXContent.isMDXComponent = true;
      